import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {CONTACT_TAB, URL} from '../../../Config/appConfig';

const focusedBackground = require('../../../resource/img/tab-focused.png');

interface ContactBannerButtonProps {
    buttonType: string,
    count: string,
    title: string,
    isSelected: boolean
}

class ContactBannerButton extends React.Component <RouteComponentProps & ContactBannerButtonProps, {}> {
    public constructor(props: ContactBannerButtonProps) {
        super(props);
        this.clickBtn = this.clickBtn.bind(this);
    }

    public clickBtn(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        let path = URL.COMPANIES;
        switch (this.props.buttonType) {
            case CONTACT_TAB.NORMAL_USER:
                path = URL.NORMAL_USERS;
                break;
            case CONTACT_TAB.API_USER:
                path = URL.API_USERS;  
                break;
        }
        this.props.history.push(path);
    }

    public render() {
        return (
            <button className={`contactBannerButton ${this.props.isSelected ? "contactBannerButtonSelected" : "cmWhiteBtn contactBannerButtonNotSelected"}`}
                    onClick={this.clickBtn}>
                {this.props.isSelected && <img src={focusedBackground}/>}
                <div className="cmBannerButtonContainer contactBannerButtonContainer">
                    <div className="contactBannerButtonCount">{this.props.count}</div>
                    <div className="cmBoldText contactBannerButtonTitle">{this.props.title}</div>
                </div>
            </button>
        );
    }
}

export default withRouter(ContactBannerButton);



// WEBPACK FOOTER //
// ./src/Components/Contact/Tab/ContactBannerButton.tsx